// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Screen = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width={size}
      height={size}
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <rect x='2.9' y='7.9' width='42' height='23.2' />
      <line x1='23.9' y1='40.1' x2='23.9' y2='31' />
      <line x1='9' y1='40.1' x2='38.6' y2='40.1' />
    </svg>
  );
};
